import MyDataHelps from "@careevolution/mydatahelps-js";

export default function getGoogleHealthProviderID() {
    var googleHealthProviderID = 49369;
    if (!MyDataHelps.baseUrl || MyDataHelps.baseUrl.startsWith("https://mdhorg.ce.dev")) {
        googleHealthProviderID = 46913;
    }
    return googleHealthProviderID;
}
